import React from 'react'
import Link from 'gatsby-link'
import logo from '../assets/logo.jpg'

const IndexPage = () => (
  <div>
    <img src={logo} />
    <h1>Witsawa Corporation</h1>
    {/* <p>Welcome to your new Gatsby site.</p> */}
    {/* <p>Now go build something great.</p> */}
    {/* <Link to="/page-2/">Go to page 2</Link> */}
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js